import { combineReducers, configureStore } from '@reduxjs/toolkit'
import userReducer from '@/redux/userSlice'
import campaignCreationReducer from '@/redux/campaignCreationSlice'
import collaborationDocumentsReducer from '@/redux/collaborationDocumentsSlice'
import { marketerApi } from '@/redux/marketerApi'
import { actionTracking } from '@/lib/actionTracking'
import mockStateJson from '@/data/mockState.json'

const rootReducer = combineReducers({
  user: userReducer,
  campaignCreation: campaignCreationReducer,
  collaborationDocuments: collaborationDocumentsReducer,
  [marketerApi.reducerPath]: marketerApi.reducer,
})

const isMockMode = import.meta.env.VITE_MOCK_STATE === 'true'

export const store = configureStore({
  reducer: rootReducer,
  // API data comes from the mock baseQuery (src/mock); only local slices are preloaded
  preloadedState: isMockMode
    ? ({
        user: mockStateJson.user,
        campaignCreation: mockStateJson.campaignCreation,
        collaborationDocuments: mockStateJson.collaborationDocuments,
      } as unknown as Partial<ReturnType<typeof rootReducer>>)
    : undefined,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(marketerApi.middleware, actionTracking),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
